import { Link } from 'react-router-dom';

export default function Impressum() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      {/* Navbar */}
      <header className="border-b border-gray-100 py-4 px-6">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link to="/">
            <img
              src="https://static.readdy.ai/image/0545d2048ed36ebe53df2dae0c0b43d7/4ab61485feffac5558181f99f1be66f6.png"
              alt="Körperformen Pinneberg"
              className="h-9 w-auto object-contain"
            />
          </Link>
          <Link
            to="/"
            className="text-xs font-medium text-gray-500 hover:text-gray-900 transition-colors flex items-center gap-1.5 whitespace-nowrap cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-left-line text-sm"></i>
            </div>
            Zurück zur Startseite
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-16 md:py-24">
        <h1
          className="text-3xl md:text-4xl font-bold text-gray-900 mb-10"
          style={{ fontFamily: 'Playfair Display, serif' }}
        >
          Impressum
        </h1>

        <div className="space-y-10 text-gray-600 text-sm leading-relaxed" style={{ fontWeight: 300 }}>

          <section>
            <h2 className="text-base font-semibold text-gray-900 mb-3" style={{ fontFamily: 'Inter, sans-serif' }}>
              Angaben gemäß § 5 TMG
            </h2>
            <p>
              Körperformen Pinneberg – EMS Gesundheitsstudio<br />
              Elmshorner Str. 3<br />
              25421 Pinneberg
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 mb-3" style={{ fontFamily: 'Inter, sans-serif' }}>
              Kontakt
            </h2>
            <p>
              Telefon: <a href="tel:017620023034" className="text-[#1A5C3D] hover:underline cursor-pointer">0176 20023034</a><br />
              E-Mail: <a href="mailto:Pinneberg@kformen.com" className="text-[#1A5C3D] hover:underline cursor-pointer">Pinneberg@kformen.com</a>
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 mb-3" style={{ fontFamily: 'Inter, sans-serif' }}>
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </h2>
            <p>
              Jonathan Bonni<br />
              Elmshorner Str. 3<br />
              25421 Pinneberg
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 mb-3" style={{ fontFamily: 'Inter, sans-serif' }}>
              Haftung für Inhalte
            </h2>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p className="mt-3">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 mb-3" style={{ fontFamily: 'Inter, sans-serif' }}>
              Haftung für Links
            </h2>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
            <p className="mt-3">
              Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 mb-3" style={{ fontFamily: 'Inter, sans-serif' }}>
              Urheberrecht
            </h2>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </section>

        </div>
      </main>

      <footer className="border-t py-8 px-6" style={{ backgroundColor: '#0D1811', borderColor: 'rgba(93,196,142,0.1)' }}>
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs" style={{ color: 'rgba(255,255,255,0.25)', fontFamily: 'Inter, sans-serif' }}>
            &copy; {new Date().getFullYear()} Körperformen Pinneberg. Alle Rechte vorbehalten.
          </p>
          <div className="flex gap-5">
            <Link to="/impressum" className="text-xs whitespace-nowrap" style={{ color: 'rgba(255,255,255,0.5)', fontFamily: 'Inter, sans-serif' }}>
              Impressum
            </Link>
            <Link to="/datenschutz" className="text-xs whitespace-nowrap hover:text-white transition-colors" style={{ color: 'rgba(255,255,255,0.25)', fontFamily: 'Inter, sans-serif' }}>
              Datenschutz
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
